<ng-container>
    <div>
        <app-switch-input id="showBilled" [form]="form" label="folder.nurseRecords.showBilled"></app-switch-input>
    </div>

    <ng-template #buttons>
        <app-button
            icon="pi-print"
            label="workData.printDialog.buttons.print"
            (clickEvent)="printRecords()"
        ></app-button>
    </ng-template>

    <app-table
        #worksTable
        tableKey="workVisits"
        [gridData]="$any(store2.works())"
        [columns]="columns"
        translatePrefix="folder.nurseRecords."
        [buttons]="extendedWorkExportsEnabled ? buttons : null"
        [hideCheckboxes]="!extendedWorkExportsEnabled"
        [showSearch]="false"
        [showColumnVisiblity]="true"
        [showDelete]="store2.isAllowed('work.delete')() && folderStore.canEdit()"
        (deleteCallbackWithEvent)="delete($event)"
        (detailCallback)="detail($event)"
        [additionalFilter]="extraFilters"
        [refreshCallback]="store2.api.getWorks"
        [refreshCallbackFragment]="workGridItemFrag"
        [defaultSorters]="[{ column: 'dateFrom', direction: 'DESC' }]"
        [rowExpansion]="rowExpansion"
    >
        @if (extendedWorkExportsEnabled) {
            <ng-template pTemplate="link" let-item="item">
                <app-button
                    styleClass="tableIcon"
                    svgIcon="pdf"
                    [text]="true"
                    (clickEvent)="$event.stopPropagation(); printRecord(item)"
                ></app-button>
            </ng-template>
        }


        <ng-template pTemplate="workData.state" let-data="data">
            <app-tag [label]="'workData.common.enum.workVisitState.' + data"
                [severity]="workVisitStateColor[data] || undefined" [rounded]="true"></app-tag>
        </ng-template>

        <ng-template pTemplate="folderFormData" let-item="item">
            <app-folder-form-data-work-column [work]="item"></app-folder-form-data-work-column>
        </ng-template>

        <ng-template #rowExpansion let-item="item">
            <div class="expnaded-grid">
                <div class="line-right" [innerHTML]="item.workData?.note || ''"></div>
                <div class="" [innerHTML]="item.workData?.medication || ''"></div>
            </div>
        </ng-template>

    </app-table>
</ng-container>
